//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PlanPricingPackage from "../../components/active/pricing_package/Index.vue";
import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";
import { mapGetters } from "vuex";
import {
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_PUBLISHER_ID,
  PARAMS,
  CURRENT_PUBLISHER_SIMPLE,
  FREE_MAX_AUTOPOST,
  DEVICE,
} from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/error";
import MulConfirm from "../../components/confirm/Mul";

export default {
  name: "ActivePage",
  components: { PlanPricingPackage, HiHeader, HiButton, MulConfirm },
  data() {
    const _this = this;
    return {
      state: "none",
      showInstagramUsers: false,
      showLoginMenu: false,
      buttons: [
        {
          text: _this.$t("addInstagramPage.loginBtn"),
          async click() {
            // _this.$router.push({ name: 'LoginInstagramPage', query: { type: 'noIns' } })
            return true;
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      currentLinkedInstagram: CURRENT_PUBLISHER_SIMPLE,
      params: PARAMS,
      freeMaxAutoPost: FREE_MAX_AUTOPOST,
      device: DEVICE,
    }),
    localIsMeImg() {
      // 获取当前国际化语言
      let local = this.language.toUpperCase();
      // 如果有 - 分割则截取后2位，
      const splitIndex = local.indexOf("-");
      if (splitIndex !== -1) {
        local = local.substr(splitIndex + 1);
      }
      return `../../../static/images/active/This_was_me/Verify Login_${local}@3x.png`;
    },
    /**
     * 计算当前选中用户是否为limited用户
     */
    isLimitedUser() {
      return !this.currentLinkedInstagram.isUnlimited;
    },
    /**
     * 计算当前unlimited账号是否已满
     */
    isUnlimitedFull() {
      return this.user.premiumPublisherRemaining === 0;
    },
  },
  methods: {
    /**
     * 跳转到my plan 页面
     */
    myPlanClick() {
      this.$router.push({ name: "MyPlanPage" });
    },
    /**
     * 打开apphi 按钮
     */
    openApphi() {
      // eslint-disable-next-line no-undef
      if (AndroidWebView && AndroidWebView.closeWebView) {
        // eslint-disable-next-line no-undef
        AndroidWebView.closeWebView(0); // 0 为未进行任何操作
      } else {
        window.location.href = "apphi-post://";
      }
    },
    /**
     * 添加account按钮点击事件
     */
    addAccountClick() {
      this.$router.push({
        name: "LoginInstagramPage",
      });
    },
    /**
     * 切换用户
     * @param index 用户索引
     */
    switchLinkedInstagram(index) {
      this.showInstagramUsers = false;
      // 切换instagram自动保存到vuex
      const publisherId = this.user.linkedInstagramList[index].publisherId;
      this.$store.commit(CURRENT_PUBLISHER_ID, publisherId);
      // 判断当前选择publisher是否需要到ins验证页面 (不是member用户 且需要重新验证密码)
      // if (this.currentLinkedInstagram.activeStatus === 'login') {
      //   this.$router.push({
      //     name: 'LoginInstagramPage',
      //     query: { username: this.currentLinkedInstagram.username, type: 'verify' }
      //   })
      // }
    },
  },
  async created() {
    // 如果发现未登录则刷新一下页面
    if (this.user === null) {
      window.location.reload();
    }
    if (!this.params) {
      if (this.user.linkedInstagramList.length === 0) {
        this.showLoginMenu = true;
      } else {
        this.switchLinkedInstagram(0);
      }
      return;
    }
    const publisherId = this.params.publisherId;
    // 如果参数存在publisherId则激活当前账号
    if (publisherId) {
      try {
        this.$loading.show();
        // 计算当前publisherId所在位置
        const currentLinkedInstagramIndex =
          this.user.linkedInstagramList.findIndex(
            (l) => l.publisherId === Number(publisherId)
          );
        this.switchLinkedInstagram(currentLinkedInstagramIndex);
        // 如果当前用户为无密码用户则不进行激活操作
        if (this.currentLinkedInstagram.activeStatus === "login") {
          return;
        }
        // 同时尝试激活当前publisher的所有post
        await this.currentLinkedInstagram.postActive();
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/active/Index.vue